import React, { useCallback, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import moment from "moment";

import Tank1 from "../../Assets/tank1.png";
import Tank2 from "../../Assets/tank2.png";
import CentralDashboardService from "../../services/centraldashboard.service";

function FuelConsumptionCentral() {
  const currentDate = new Date();
  const [showCalendar, setShowCalendar] = useState(false);
  const [showCalendar2, setShowCalendar2] = useState(false);

  const [formdate, setFormdate] = useState(
    moment(new Date(currentDate)).format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    moment(new Date(currentDate)).format("YYYY-MM-DD")
  );

  const [details, setDetails] = useState({
    fromDate: moment(new Date(currentDate)).format("YYYY-MM-DD"),
    formatedFromDate: moment(new Date(currentDate)).format("DD-MM-YY"),
    toDate: moment(new Date(currentDate)).format("YYYY-MM-DD"),
    formatedToDate: moment(new Date(currentDate)).format("DD-MM-YY"),
  });

  const [graphData, setGraphData] = useState([
    {
      tank: "Indian Oil",
      data: ["0", "0", "0"],
    },
    {
      tank: "Bharat Petroleum",
      data: ["0", "0", "0"],
    },
  ]);

  const fetchFuelConsumptionData = useCallback(() => {
    const payload = {
      fromdate: details.fromDate,
      todate: details.toDate,
    };
    CentralDashboardService.fetchFuelConsume(payload)
      .then((resp) => {
        // console.log(resp.data);

        const locations = ["Gangtok", "Jalipool", "Rangpo"];

        const graphData = [
          {
            tank: "Indian Oil",
            data: locations.map((location) => {
              const entry = resp.data.find(
                (entry) =>
                  entry.pumpno === "1" && entry.locationName === location
              );
              return entry ? entry.totalConsumefuel : "0";
            }),
          },
          {
            tank: "Bharat Petroleum",
            data: locations.map((location) => {
              const entry = resp.data.find(
                (entry) =>
                  entry.pumpno === "2" && entry.locationName === location
              );
              return entry ? entry.totalConsumefuel : "0";
            }),
          },
        ];

        setGraphData(graphData);
      })
      .catch((e) => console.log(e));
  }, [details.fromDate, details.toDate]);

  useEffect(() => {
    fetchFuelConsumptionData();
  }, [fetchFuelConsumptionData]);

  const formatMonthYear = (locale, date) => {
    return `${currentDate.getDate()} ${currentDate.toLocaleDateString(locale, {
      month: "long",
    })}, ${currentDate.getFullYear()}`;
  };

  const handleChange = (newValue) => {
    setFormdate(newValue);
    setDetails({
      ...details,
      fromDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedFromDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });
    setShowCalendar(false);
  };

  const handleChange2 = (newValue) => {
    setToDate(newValue);
    setDetails({
      ...details,
      toDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedToDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });
    setShowCalendar2(false);
  };

  const gradient = document.createElement("canvas").getContext("2d");
  const gradientFill = gradient.createLinearGradient(0, 0, 0, 250);
  const gradientFill2 = gradient.createLinearGradient(0, 0, 0, 250);

  gradientFill.addColorStop(0, "rgba(248, 159, 82, 1)"); // Start color
  gradientFill.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  gradientFill2.addColorStop(0, "rgba(254, 224, 105, 1)"); // Start color
  gradientFill2.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  // console.log(graphData);

  const gradients = [gradientFill, gradientFill2];

  const images = [Tank1, Tank2];

  const customDatasets = Array.isArray(graphData)
    ? graphData.map((item, index) => ({
        label: item.tank,
        data: item.data,
        backgroundColor: gradients[index],
        barPercentage: 0.75,
        categoryPercentage: 0.75,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 6,
          topRight: 6,
          bottomLeft: 6,
          bottomRight: 6,
        },
        borderSkipped: false,
        image: images[index],
      }))
    : null;

  // console.log(customDatasets);

  const chartData = {
    labels: ["Gangtok", "Jalipool", "Rangpo"],
    datasets: customDatasets ? customDatasets : [],
    // datasets: [
    //   {
    //     label: "Indian Oil",
    //     data: ["50", "120", "80"],
    //     backgroundColor: gradientFill,
    //     barPercentage: 0.75,
    //     categoryPercentage: 0.75,
    //     borderWidth: 1,
    //     borderColor: "white",
    //     borderRadius: {
    //       topLeft: 6,
    //       topRight: 6,
    //       bottomLeft: 6,
    //       bottomRight: 6,
    //     },
    //     borderSkipped: false,
    //     image: Tank1,
    //   },
    //   {
    //     label: "Bharat Petroleum",
    //     data: ["100", "210", "150"],
    //     backgroundColor: gradientFill2,
    //     barPercentage: 0.75,
    //     categoryPercentage: 0.75,
    //     borderWidth: 1,
    //     borderColor: "white",
    //     borderRadius: {
    //       topLeft: 6,
    //       topRight: 6,
    //       bottomLeft: 6,
    //       bottomRight: 6,
    //     },
    //     borderSkipped: false,
    //     image: Tank2,
    //   },
    // ],
  };

  const barImagePlugin = {
    id: "barImagePlugin",
    afterDatasetsDraw(chart, args, plugin) {
      const { ctx, data } = chart;

      data.labels.forEach((label, index) => {
        const xPos = chart.getDatasetMeta(0).data[index].x;
        const yPos = chart.getDatasetMeta(0).data[index].y;

        const xPos1 = chart.getDatasetMeta(1).data[index].x;
        const yPos1 = chart.getDatasetMeta(1).data[index].y;

        const chartImage = new Image();
        const chartImage1 = new Image();

        chartImage.src = data.datasets[0].image;
        chartImage1.src = data.datasets[1].image;

        if (data.datasets[0].data[index] !== "0") {
          ctx.drawImage(chartImage, xPos - 15, yPos + 5, 30, 30);
          ctx.fillText(`${data.datasets[0].data[index]} Ltr`, xPos, yPos - 5);
        } else {
          ctx.drawImage(chartImage, xPos - 15, yPos - 35, 30, 30);
          ctx.fillText(`${data.datasets[0].data[index]} Ltr`, xPos, yPos - 40);
        }

        if (data.datasets[1].data[index] !== "0") {
          ctx.drawImage(chartImage1, xPos1 - 15, yPos1 + 5, 30, 30);
          ctx.fillText(`${data.datasets[1].data[index]} Ltr`, xPos1, yPos1 - 5);
        } else {
          ctx.drawImage(chartImage1, xPos1 - 15, yPos1 - 35, 30, 30);
          ctx.fillText(
            `${data.datasets[1].data[index]} Ltr`,
            xPos1,
            yPos1 - 40
          );
        }
      });

      // Add custom text above each label
      data.labels.forEach((label, index) => {
        const xPos = chart.getDatasetMeta(0).data[index].x + 30;
        const yPos = chart.scales.y.top - 20;
        ctx.font = "bold 12px Jost";
        ctx.fillStyle = "rgba(78, 70, 94, 1)";
        ctx.textAlign = "center";
        ctx.fillText(
          `Total ${
            parseInt(data.datasets[0].data[index]) +
            parseInt(data.datasets[1].data[index])
          } Ltr`,
          xPos,
          yPos
        );
      });
    },
  };

  const options = {
    responsive: true,
    offset: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        display: true,
        grid: {
          display: true,
        },
        border: {
          display: false,
        },
        title: {
          display: true,
          text: "Fuel Consumed (LTRs)",
        },
        ticks: {
          beginAtZero: true,
          stepSize: 10000,
        },
      },
    },
    layout: {
      padding: {
        top: 35,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
      barImagbarImagePlugin: true,
      tooltip: {
        displayColors: false,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        bodyFont: {
          size: 14,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 15,
          family: "Jost, sans-serif",
        },
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <>
      <div>
        <div className="graph-header">
          <div className="graph-heading">Fuel Consumption</div>
          <div className="slider-right">
            <div className="">
              <span
                className="fill"
                style={{ backgroundColor: "rgba(248, 159, 82, 1)" }}
              ></span>
              <span>Indian Oil</span>
            </div>
            <div className="">
              <span
                className="fill"
                style={{ backgroundColor: "rgba(254, 224, 105, 1)" }}
              ></span>
              <span>Bharat Petroleum</span>
            </div>
          </div>
          <div className="date-range" style={{ display: "flex" }}>
            <div className="flex position-relative">
              <span>
                {details.formatedFromDate !== ""
                  ? details.formatedFromDate
                  : "From"}
              </span>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={(e) => {
                    setShowCalendar(true);
                    setShowCalendar2(false);
                  }}
                >
                  <path
                    d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.83333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                    stroke="#6E6284"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              {showCalendar && (
                <div className="calendarModal position-absolute">
                  <Calendar
                    formatMonthYear={formatMonthYear}
                    maxDate={currentDate}
                    onChange={handleChange}
                    value={formdate}
                  />
                </div>
              )}
            </div>
            <div className="flex position-relative">
              <span>
                {details.formatedToDate !== "" ? details.formatedToDate : "To"}
              </span>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={(e) => {
                    setShowCalendar2(true);
                    setShowCalendar(false);
                  }}
                >
                  <path
                    d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.83333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                    stroke="#6E6284"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              {showCalendar2 && (
                <div className="calendarModal position-absolute">
                  <Calendar
                    formatMonthYear={formatMonthYear}
                    onChange={handleChange2}
                    value={toDate}
                    minDate={formdate}
                    maxDate={currentDate}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${showCalendar ? "modal-overlay" : ""}`}
        onClick={(e) => {
          setShowCalendar(false);
        }}
      >
        <div className="" onClick={(e) => e.stopPropagation()}></div>
      </div>

      <div
        className={`${showCalendar2 ? "modal-overlay" : ""}`}
        onClick={(e) => {
          setShowCalendar2(false);
        }}
      >
        <div className="" onClick={(e) => e.stopPropagation()}></div>
      </div>

      <div className="">
        <Bar
          data={chartData}
          options={options}
          plugins={[barImagePlugin]}
          width={600}
          height={300}
        />
      </div>
    </>
  );
}

export default FuelConsumptionCentral;
